import React from "react";
import PropTypes from "prop-types";

import { CardBox, SplitPanel, NotificationText, Panel } from "../CardsStyled";

export const NotificationSent = ({ description }) => (
  <CardBox>
    <SplitPanel>
      <Panel>
        <NotificationText>{description}</NotificationText>
      </Panel>
    </SplitPanel>
  </CardBox>
);

NotificationSent.propTypes = {
  description: PropTypes.string.isRequired
};

export default NotificationSent;
